import styled from '@emotion/styled'
import Breadcrumb from '../../../../components/common/Breadcrumb'
import Card from '../../../../components/common/Card'
import { mobile, useScreen } from '../../../../utils/responsive-helper'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import iconEnroll from '../../../../assets/images/icons-enroll-2-32-px.svg'
import { FONT_LIGHT_GRAY, PRIMARY } from '../../../../constant/colors'
import { useCallback, useMemo, useState } from 'react'
import Select from '../../../../components/common/Select'
import FooterContent from '../../../../components/FooterContent'
import Button from '../../../../components/common/Button'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useRouter } from '../../../../utils/helper'
import {
  useCreateLeaveCoin,
  useGetAllBenefits,
} from '../../../../services/enrollment/enrollment-query'
import ModalAcceptPrivacy from '../../ModalAcceptPrivacy'
import { useVisibility } from '../../../../utils/custom-hook'
import { notification } from 'antd'
import { LeaveBenefitParams } from '../../../../services/enrollment/enrollment-types'
import { useGetUserCoin } from '../../../../services/user/user-query'
import { SummaryPoint } from '../EditBenefits/shared'
import { pullAt } from 'lodash'
import { useGetEnrollmentYear } from '../..'

const Layout = styled.div`
  > * {
    margin-top: 24px;
  }
  text-align: center;
`

const LayoutTopic = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  width: 100%;
`

const IconStyle = styled.div`
  padding-right: 16px;
`

const LayoutContentTopic = styled.div`
  display: flex;
  text-align: start;
  position: relative;
  flex-direction: column;
  width: 100%;
`

const CustomStyleCard = styled(Card)`
  display: flex;
  /* position: relative; */
  flex-direction: column;
  width: 100%;
  padding-bottom: 32px;
  padding-top: 32px;
  margin-bottom: 24px;
  ${mobile} {
    padding-top: 16px;
  }
`

const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  margin-bottom: 24px;
  margin-left: 24px;
  margin-right: 24px;
  ${mobile} {
    margin-bottom: 16px;
    margin-left: 16px;
    margin-right: 16px;
  }
`
const ContentPoint = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  margin-top: 8px;
  margin-left: 98px;
  margin-right: 98px;
  ${mobile} {
    margin-left: 16px;
    margin-right: 16px;
  }
`

const ContentSelection = styled.div`
  text-align: start;
  margin-left: 98px;
  margin-right: 98px;
  ${mobile} {
    margin-left: 16px;
    margin-right: 16px;
  }
`

const Header = styled.div`
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
`

const ButtonStyle = styled(Button)`
  width: 267px;
`

const leaveOpt = [
  // {
  //   label: '0 วัน',
  //   value: 0,
  // },
  {
    label: '1 วัน',
    value: 1,
  },
  {
    label: '2 วัน',
    value: 2,
  },
  {
    label: '3 วัน',
    value: 3,
  },
  {
    label: '4 วัน',
    value: 4,
  },
]

const EnrollmentLeave = () => {
  const { t } = useTranslation()
  const screen = useScreen()
  const { isMobile } = screen
  const { query } = useRouter()
  const { enrollmentYear } = useGetEnrollmentYear()
  const { data: allBenefits, isLoading } = useGetAllBenefits(query?.benefitYearId)

  const { data: userCoin } = useGetUserCoin()
  // const userCoinDigit = userCoin?.toLocaleString(undefined, { maximumFractionDigits: 2 })

  const { mutate: createLeaveCoin } = useCreateLeaveCoin()

  const label = leaveOpt.find((v) => {
    if (v.value === allBenefits?.userLeaveBenefits) {
      return v
    }
  })

  const [valueObject, setValueObject] = useState({
    leaveBenefit: label?.value,
  })

  const userPoint = useMemo(() => userCoin || 0, [userCoin])
  const sumLeave = useMemo(() => (valueObject.leaveBenefit || 0) * 100, [valueObject.leaveBenefit])
  const remainPoint = useMemo(() => userPoint + sumLeave, [sumLeave, userPoint])

  const onSelect = useCallback((key, index) => {
    setValueObject((valueObject) => ({ ...valueObject, [index]: key }))
  }, [])

  const leaveBenefitOptions = [...leaveOpt]
  const [visible, modalAction] = useVisibility()

  const onConfirmLeave = () => {
    modalAction.hide()
    const params: LeaveBenefitParams = {
      enrollmentId: 1,
      dayLeave: valueObject.leaveBenefit ?? 0,
    }

    createLeaveCoin(params, {
      onSuccess: () => {
        notification.success({
          message: 'Success',
        })
      },
      onError: () => {
        notification.error({
          message: 'Fail',
        })
      },
    })
  }

  return (
    <Layout>
      <ModalAcceptPrivacy
        visible={visible}
        onConfirmClick={onConfirmLeave}
        onCloseClick={modalAction.hide}
      />
      {!isMobile && (
        <Breadcrumb
          overide={(paths) => {
            // paths.unshift({ label: 'Home', path: '/' })
            pullAt(paths, 5, 6)
            paths[0].label = t('ปรับเปลี่ยนสวัสดิการ')
            paths[1].label = t(`ดูสวัสดิการปี ${enrollmentYear}`)
            paths[2].label = t(`สวัสดิการปี ${enrollmentYear} ของฉัน`)
            paths[3] = {
              label: t('แลกเปลี่ยนคะแนน'),
              path: '',
            }
            return paths
          }}
        />
      )}
      <Header>
        <Text size={28} type="Bold">
          แลกเปลี่ยนคะแนน
        </Text>
      </Header>
      <LayoutTopic>
        <IconStyle>
          <Image src={iconEnroll} width={32} height={32} />
        </IconStyle>
        <LayoutContentTopic>
          <Text size={24} type="Bold">
            แลกวันลา
          </Text>
          <Text size={22} color={FONT_LIGHT_GRAY} type="Medium">
            วันลาที่แลกได้คือวันลงของปี{' '}
            {dayjs()
              .add(543 + 1, 'year')
              .year()}{' '}
            เท่านั้น
          </Text>
        </LayoutContentTopic>
      </LayoutTopic>
      <CustomStyleCard>
        <ContentCard>
          <Text size={24} type="Bold">
            ระบุจำนวนวันลาที่ต้องการแลก
          </Text>
          <Text size={20} color={FONT_LIGHT_GRAY} style={{ paddingTop: '8px' }}>
            (แลกได้ไม่เกิน 4 วัน)
          </Text>
        </ContentCard>
        <ContentSelection>
          <Select
            options={leaveBenefitOptions}
            placeholder="จำนวนวันลาที่ต้องการแลก"
            value={valueObject.leaveBenefit}
            onSelect={(key: string | number) => onSelect(key, 'leaveBenefit')}
          />
        </ContentSelection>
        <ContentPoint>
          <Text size={18} color={PRIMARY}>
            แลกได้ +100 คะแนนต่อวัน
          </Text>
        </ContentPoint>
      </CustomStyleCard>
      <FooterContent
        style={{
          paddingTop: '24px',
          paddingBottom: '24px',
          marginLeft: '8px',
          marginRight: '8px',
          display: 'flex',
          justifyContent: isMobile ? 'center' : 'space-between',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Text size={22} type="Bold">
            รวมใช้คะแนน
          </Text>
          <SummaryPoint>
            <Text size={22} type="Bold" color={PRIMARY} style={{ paddingLeft: '8px' }}>
              {sumLeave.toLocaleString(undefined, { maximumFractionDigits: 2 })}
            </Text>
            <Text size={20} style={{ paddingLeft: '8px' }}>
              คะแนน
            </Text>
            <Text size={20} color={FONT_LIGHT_GRAY} style={{ paddingLeft: '8px' }}>
              (คงเหลือ {remainPoint.toLocaleString(undefined, { maximumFractionDigits: 2 })} คะแนน)
            </Text>
          </SummaryPoint>
        </div>

        <ButtonStyle
          disabled={valueObject.leaveBenefit === undefined ? true : false}
          onClick={modalAction.show}
        >
          เลือก
        </ButtonStyle>
      </FooterContent>
    </Layout>
  )
}

export default EnrollmentLeave
